<template>
    <div class="uk-grid">
        <div v-for="item in items" class="uk-width-1-2@s uk-width-1-3@m">
            <div class="uk-article" :class="{ focus: item.focus}" data-uk-rr-grid-item>
                <div class="news-card uk-card uk-card-small uk-card-default">
                    <div class="news-card__media uk-card-media-top" v-if="item.featured_media && item.featured_media.data.is_image">
                        <a :href="item.url" v-html="item.featured_media.data.thumbnail"></a>
                    </div>

                    <div class="news-card__body uk-card-body">
                        <p class="news-card__title uk-card-title uk-margin-remove"><a :href="item.url" class="uk-link-heading">{{item.title}}</a></p>
                        <div class="news-card__meta uk-text-meta">
                            <div class="uk-flex-middle" uk-grid>
                                <div class="uk-width-auto" v-if="item.author">
                                    <img class="uk-border-circle" :src="item.author.data.avatar" :alt="item.author.data.present">
                                    <span>{{item.author.data.present}}</span>
                                </div>
                                <div class="uk-width-expand">
                                    <time :content="item.published_at.long">{{item.published_at.long}}</time>
                                </div>
                            </div>
                        </div>
                        <p v-if="item.subtitle" class="news-card__subtitle uk-margin-remove-bottom uk-text-bold">{{item.subtitle}}</p>
                        <p v-if="item.abstract" class="news-card__text uk-margin-remove-top">{{item.abstract}}</p>
                        <div class="news-card__tags">
                            <p class="uk-margin-small-bottom" v-if="item.categories">
                                <i class="fal fa-sitemap fa-fw"></i>
                                <span class="uk-badge" v-for="category in item.categories.data">{{category.present}}</span>
                            </p>
                            <p class="uk-margin-remove-top" v-if="item.tags">
                                <i class="fal fa-tag"></i>
                                <span class="uk-badge" v-for="tag in item.tags.data">{{tag.present}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/collections/assets/js/components/NewsDataGridResults.vue